import React from 'react';
import {FormattedMessage, IntlProvider} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';

export default {
    key: "breaksContentCenterSection",
    props: {
        headerKey: 'Loyalty Content Center'
    },
    fields: [
        {
            type: 'image',
            name: 'loyaltyContentCenterImageId',
            idFor: 'loyaltyContentCenterImage',
            required: false,
            props: {
                labelKey: 'Content Center Image',
                imageType: 'custom',
                helperText: 'Image for the loyalty content center section'
            }
        },
        {
            type: 'text',
            name: 'loyaltyContentCenterBreakName',
            required: false,
            props: {
                labelKey: 'Content Center Break Name',
                placeholderKey: 'Enter break name for content center',
                validationRules: []
            }
        },
        {
            type: 'text',
            name: 'ctaCopy',
            required: false,
            props: {
                labelKey: 'CTA Copy',
                placeholderKey: 'Enter call-to-action copy',
                validationRules: []
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/breaksContentCenterSection.js